<script>
import Vuex from 'vuex'
import { db, mixin, indexOf, incrementCounter } from './common.js'
import backArrow from './design/back-arrow.vue'
export default {
  components: {
    'back-arrow': backArrow
  },
  mixins: [mixin],
  props: ['pageId', 'itemId'],
  data: () => ({
    imagePositions: {
      main: 'item-main-image',
      sub: 'item-sub-image'
    },
    item: {}
  }),
  computed: {
    ...Vuex.mapState({
      user: 'user',
      page: 'page',
      imageSourceQueue: 'imageSourceQueue'
    }),
    pageTitle () {
      return this.page.title || ''
    },
    mainImage () {
      return this.item.images[0] || {}
    },
    validName () {
      return this.item.name && this.item.name.length <= 30
    },
    validPrice () {
      return this.item.price.value !== '' &&
        Number.isInteger(this.item.price.value - 0) &&
        this.item.price.value >= 0
    }
  },
  watch: {
    page (value) {
      this.item = Object.assign({}, this.page.items[this.itemId])
    },
    imageSourceQueue (value) {
      const index = indexOf(value, 'position', this.imagePositions.main)
      if (index === false) {
        return false
      }
      this.item.images.splice(0, 1, value[index])
      this.$store.commit('dequeueImageSource')
      const image = this.item.images[0]
      if (!this.item.images[0].id) {
        incrementCounter(db.doc('pages/' + this.page.id), 'images_counter')
          .then(n => (image.id = n))
          .catch(error => console.error(error))
      }
    }
  },
  methods: {
    takePicture (position) {
      this.$store.commit('storeImagePosition', position)
      document.querySelector('#image-capture input').click()
    },
    saveItem () {
      if (this.item.id) {
        this.$store.dispatch('updatePageItem', this.item)
      } else {
        this.$store.commit('enqueueAsync')
        incrementCounter(db.doc('pages/' + this.page.id), 'items_counter')
          .then(n => {
            this.item.id = n
            this.$store.dispatch('updatePageItem', this.item)
          })
          .finally(() => this.$store.commit('dequeueAsync'))
      }
      this.$router.go(-1)
    },
    deleteItem () {
      if (confirm(this.item.name + 'を削除します。よろしいですか？')) {
        this.$store.dispatch('deletePageItem', this.itemId)
      }
    }
  },
  created () {
    if (this.page.id !== this.pageId) {
      this.$router.replace({name: 'item'})
    } else if (this.itemId === 'new') {
      this.item = {images: [], price: {tax: true, value: ''}}
    } else {
      const item = this.page.items[indexOf(this.page.items, 'id', this.itemId)]
      this.item = JSON.parse(JSON.stringify(item))
    }
  }
}
</script>

<template>
  <div id="item-editor" class="editor">
    <nav class="sub-page-nav has-text-centered">
      <back-arrow></back-arrow>
      <h1 class="is-cs-3">商品編集</h1>
    </nav>
    <div class="wrapper">
      <div class="main-image">
        <div class="has-text-weight-bold">メイン商品画像</div>
        <figure
          class="image"
          v-for="(image, i) in [mainImage]"
          :key="i"
        >
          <cachalog-img
            :type="'background'"
            :caption="image.caption"
            :full-path="image.full_path"
            :source="image.source"
            :edit="true"
          />
          <div
            class="camera-icon"
            @click="takePicture(imagePositions.main)"
          >
            <i class="c-icon cachalog-camera">
              <span class="path1"></span><span class="path2"></span>
            </i>
          </div>
        </figure>
      </div>
      <div class="properties">
        <div class="name">
          <label for="form-name">商品名</label>
          <input
            type="text"
            name="name"
            id="form-name"
            placeholder="必須項目です"
            v-model="item.name"
          >
          <p
            class="notice is-c-alert-text has-text-centered"
            v-if="!validName && item.name"
          >
            30文字以内で入力してください。
          </p>
        </div>
        <div class="price">
          <label for="form-price">価格</label>
          <input
            type="number"
            pattern="^[0-9]*$"
            name="price"
            id="form-price"
            placeholder="0"
            v-model="item.price.value"
          >
          <span>円（税込）</span>
          <p
            class="notice is-c-alert-text has-text-centered"
            v-if="!validPrice && item.price.value"
          >
            整数を入力してください。
          </p>
        </div>
        <div class="sold-out">
          <label for="form-sold-out"></label>
          <input
            type="checkbox"
            name="sold-out"
            id="form-sold-out"
            v-model="item.sold_out"
          >
          <label for="form-sold-out">売り切れにする</label>
        </div>
        <div class="description">
          <label for="form-description">紹介</label>
          <textarea
            name="description"
            id="form-description"
            rows="10"
            v-model="item.description"
          ></textarea>
        </div>
        <div class="r18">
          <label for="form-r18">制限</label>
          <input
            type="checkbox"
            name="r18"
            id="form-r18"
            v-model="item.r18"
          >
          <label for="form-r18">R18コンテンツである</label>
        </div>
      </div>
      <div class="has-text-centered">
        <button
          class="button is-rounded is-c-primary is-large"
          :disabled="!validName || !validPrice"
          @click="saveItem"
        >
          保存
        </button>
      </div>
      <div class="has-text-centered" v-if="itemId !== 'new'">
        <button
          class="button is-rounded is-c-alert is-large"
          @click="deleteItem"
        >
          商品の削除
        </button>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/item-editor.vue